import { Component } from '@angular/core';

@Component({
  selector: 'app-section-pilares',
  templateUrl: './section-pilares.component.html',
  styleUrls: ['./section-pilares.component.scss'],
})
export class SectionPilaresComponent {

  openExternalLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
